module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', {
    on: {
      "open": _vm.onOpen,
      "restore": _vm.onRestore,
      "close": _vm.onClose
    }
  }, [_c('list', {
    ref: "list",
    attrs: {
      "loadNextPage": _vm.loadNextPage,
      "clear": _vm.clear
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('router-link', {
      key: index,
      staticClass: "item",
      attrs: {
        "to": {
          name: 'news-detail',
          params: {
            id: item.id
          }
        }
      }
    }, [_c('span', [_vm._v(_vm._s(index + 1) + ". " + _vm._s(item.title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("date")(item.addtime))), _c('i', {
      staticClass: "icon icon-right"
    })])])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "tab fixedTop"
  }, _vm._l((_vm.types), function(item, index) {
    return _c('a', {
      class: {
        on: _vm.type === index
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.onSwitch(index)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f5daedb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/news/index.vue
// module id = 314
// module chunks = 0